import { render, staticRenderFns } from "./AssignMovementModal.vue?vue&type=template&id=0f7857a3&scoped=true&"
import script from "./AssignMovementModal.vue?vue&type=script&lang=js&"
export * from "./AssignMovementModal.vue?vue&type=script&lang=js&"
import style0 from "./AssignMovementModal.vue?vue&type=style&index=0&id=0f7857a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7857a3",
  null
  
)

export default component.exports